<script setup lang="ts">
import PdsIconButton from '@/components/pds/PdsIconButton.vue';
import PdsSegmented from '@/components/pds/PdsSegmented.vue';
import PdsThemeSwitch from '@/components/pds/PdsThemeSwitch.vue';
import { computed } from 'vue';
import { RouterLink } from 'vue-router';
import { usePdsOrdersStore } from '../stores/orders.store';
import BrandClock from './BrandClock.vue';
import type { PdsStageFilter } from '../types';

defineEmits<{ menu: [] }>();

const store = usePdsOrdersStore();

const filter = computed({
  get: () => store.stageFilter,
  set: (value: PdsStageFilter) => (store.stageFilter = value),
});

const options = computed(() => [
  { value: 'all' as const, label: `Toutes · ${store.activeCount}` },
  { value: 'new' as const, label: `Nouvelles · ${store.newOrders.length}` },
  {
    value: 'preparing' as const,
    label: `En préparation · ${store.preparingOrders.length}`,
  },
  { value: 'ready' as const, label: `Prêtes · ${store.readyOrders.length}` },
]);
</script>

<template>
  <header
    class="bg-carte border-filet flex shrink-0 flex-wrap items-center gap-x-2 gap-y-2 border-b px-4 py-3 sm:gap-x-3 sm:px-5 lg:h-[72px] lg:flex-nowrap lg:py-0"
  >
    <BrandClock />

    <div class="min-w-0 flex-1"></div>
    <div class="min-w-0 max-lg:order-last max-lg:basis-full">
      <PdsSegmented v-model="filter" :options="options" />
    </div>
    <RouterLink
      v-if="store.lateOrders.length"
      to="/retards"
      class="bg-alerte-doux text-alerte-texte flex h-12 shrink-0 items-center gap-[10px] rounded-[24px] pr-[10px] pl-4 text-[14px] leading-[1.4] font-semibold max-[400px]:pl-[10px]"
    >
      <span class="max-[400px]:sr-only">En retard</span>
      <span
        class="bg-alerte text-alerte-encre flex h-6 items-center rounded-[12px] px-2 text-[12px] leading-[1.45]"
      >
        {{ store.lateOrders.length }}
      </span>
    </RouterLink>
    <div class="hidden min-w-0 flex-1 lg:block"></div>

    <div class="hidden xl:block"><PdsThemeSwitch /></div>
    <PdsIconButton
      icon="search"
      label="Rechercher"
      :to="{ name: 'pds-search' }"
    />
    <PdsIconButton icon="menu" label="Menu" @click="$emit('menu')" />
  </header>
</template>
